import $ from "jquery";

import { hideChat } from "#scripts/dialog/dialog_general.js";
import { dialogEvents } from "#scripts/dialog/dialog_events.js";
import { initBotInstance } from "#scripts/dialog/dialog_messages.js";
import { contentMeta, isMobile } from "#scripts/general_functions";
import { getImageByContentId } from "#scripts/images";
// import kariAvatar from '#scripts/kariavatar.js';
import language from "#scripts/translation";
import { getLangForApi } from "#scripts/cmsapi.js";
import * as Sentry from "@sentry/browser";

window.messagequeue = [];
export const getFrontpageImages_old = async (load = 1, from = 0) => {
  const frontImageContentTypeId = "17c15981-758d-4d09-a7ee-b2d47d2af6f0"; // Forsidebilde
  const apiCall = `${window.apiUrl}/Public/articles?subscriptionId=${window.serverdata.configMeta.aim.clientId}&contentType=${frontImageContentTypeId}
      &limit=${load}&offset=${from}&sortOrder=Published&language=${getLangForApi()}`;
  // const response = await fetch(apiCall);
  // const imagesList = await response.json();
  try {
    const response = await fetch(apiCall);
    if (!response.ok) {
      // throw new Error(`HTTP error! status: ${response.status}`);
      Sentry.captureMessage(`HTTP error! status: ${response.status}`);
    }
    const imagesList = await response.json();
    return imagesList;
  } catch (error) {
    // console.error("Error fetching or parsing data:", error);
    Sentry.captureException(error);
  }
};

export const getFrontpageImages = async (load = 1, from = 0) => {
  const frontImageContentTypeId = "17c15981-758d-4d09-a7ee-b2d47d2af6f0"; // Forsidebilde
  const apiCall = `${window.apiUrl}/Public/articles?subscriptionId=${window.serverdata.configMeta.aim.clientId}&contentType=${frontImageContentTypeId}
      &limit=${load}&offset=${from}&sortOrder=Published&language=${getLangForApi()}`;

  return fetch(apiCall)
    .then((response) => {
      if (!response.ok) {
        const errorMessage = `HTTP error! status: ${response.status}`;
        Sentry.captureMessage(errorMessage);
        // throw new Error(errorMessage);
      }
      return response.json();
    })
    .then((imagesList) => {
      return imagesList;
    })
    .catch((error) => {
      Sentry.captureException(error);
      // console.error("Error fetching or parsing data:", error);
      // throw error; // Re-throw the error after logging it
    });
};

export default function () {
  /* Start template */
  const KariStartTemplate = () => {
    const config = JSON.parse(sessionStorage.getItem("config"));

    // let kari = kariAvatar() || "";
    const kari = "";
    let extraKariLink = "";

    if (config.kariinfoLinkId) {
      extraKariLink = `
                    <a href="/artikkel/${config.kariinfoLinkId}" class="dialog__actions__ddlink" aria-label="${language("DIALOG_EXTRALINK")} (${language("NAV_OPEN_I_NEW")})" target=_blank>${language(
        "DIALOG_EXTRALINK",
      )} <span class="material-icons-outlined notranslate">open_in_new</span></a>`; // cbb18a77-460f-41b4-92e7-3547f8bfdf9e
    }

    const kariHtml = `
            <div class="chatbot__mobile__header">
            
                <div class="row">
                    <div class="col-6">
                        <span class="chatbot__modal__header">
                        Kommune-Kari
                        </span>
                    </div>
                    <div class="col-6 text-right chatbot__modal__icons">
                        <button class="chatbot__modal__button chatbot__modal__option" id="chatbot__modal__option" aria-label="hjelp"><span class="material-icons-outlined notranslate">help_outline</span></button>
                        <button class="chatbot__modal__button chatbot__modal__close" id="chatbot__modal__close"aria-label="lukk"><span class="material-close-ui"></span></button>
                    </div>
                </div>
            </div>
            
            <div class="chatbot__infopage">
                <div class="container dialog__infopage__container">
                    <div class="row">
                        <div class="col-12 text-center">
                            <a href="#" class="dialog__actions__ddlink restart-chat">${language("DIALOG_RESTART")}</a>
                            <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                            <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                            <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">${language(
      "DIALOG_PRIVACY",
    )} <span class="material-icons-outlined notranslate">open_in_new</span></a>
                            ${extraKariLink}
                            
                            <button class="chatbot__infopage__close" id="chatbot__infopage__close">Tilbake</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="chatbot-search chatbot-search--container" data-background="">
                <!--div class="dialog__overlay__color"></div-->
                <div class="dialog__overlay__graph-right"><img src="" alt=""/></div>
                <!--div class="dialog__overlay__graph-left"></div-->
                <div class="container dialog__messagearea__container" id="chatbot__messagearea">
                  <div class="row h-100">
                    <div class="col-lg-8 h-100">
                      <div class="dialog dialog__messagearea h-100">
                        <div class="dialog__scroller" id="dialog__scroller">
                          <div class="justify-content-lg-center jcm-tostart">
                            <div class="xcol-lg-10">
                              <div id="kari__dialog__window" class="dialog__container"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container dialog__inputarea__container">
                  <div class="row">
                    <div class="col-lg-8">
                      <div class="dialog dialog__inputarea">
                        <div class="xrow justify-content-lg-center jcm-toend">
                          <div class="xcol-lg-10">
                            <div class="dialog__avatarcontainer dialog__avatarcontainer-input">${kari}</div>
                            <div class="dialog__inputcontainer">
                              <input type="text" 
                                  class="form-control dialog__input" 
                                  id="tilbakemelding" 
                                  maxlength="110"
                                  autocomplete="off" 
                                  aria-label="${language("DIALOG_FEEDBACK")}" 
                                  aria-describedby="chatinput__beskrivelse" 
                                  placeholder="${language("START_OR_SEARCH")}">
                              <label for="tilbakemelding" 
                                  class="d-none">${language("DIALOG_FEEDBACK")}</label>
                              <small id="chatinput__beskrivelse" 
                                  class="d-none text-muted">${language("DIALOG_MUTEINPUT")}</small>
                              <button type="button" class="dialog__sendbutton" aria-label="${language("DIALOG_SENDBTN")}">
                                  <span class="material-icons-outlined notranslate dialog__sendbutton__icon"></span>
                              </button>
                              <div id="chatinput__char-counter" class="dialog__input-counter"></div>
                            </div>
                            <div class="dialog__askarea">
                              <button type="button" class="dialog__askbutton" aria-label="${language("DIALOG_ASKME")}" role="button">Spør meg
                                <span class="material-icons-outlined notranslate buttonrow__button__icon">arrow_forward</span>
                              </button>
                            </div>
                            <div class="dialog__actions__container">
                              <a href="#" class="dialog__actions__link restart-chat dialog__actions__link-hidden">
                                ${language("DIALOG_RESTART")}
                                <span class="material-icons-outlined notranslate">refresh</span>
                              </a>
                              <a href="#" class="dialog__actions__link dialog__actions__toggle">
                                ${language("DIALOG_INFORMATION")}<span class="dialog__chevron__toggle material-icons-outlined material-chevron-bottom notranslate"></span>
                              </a>
                              <div class="dialog__actions">
                                  <a href="#" class="dialog__actions__ddlink download">${language("DIALOG_DOWNLOAD_CONVERSATION")}</a>
                                  <a href="#" class="dialog__actions__ddlink deletedialog">${language("DIALOG_DELETE_CONVERSATION")}</a>
                                  <a href="https://prokom.no/produkter-og-tjenester/chatbots/kari/om-personvern/" target=_blank class="dialog__actions__ddlink seePrivacy">
                                    ${language("DIALOG_PRIVACY")} 
                                    <span class="material-icons-outlined notranslate">open_in_new</span>
                                  </a>
                                  ${extraKariLink}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        `;

    $("#chatbot__container").append(kariHtml);
    if (isMobile()) {
      $("#chatbot__container").addClass("chatbot__mobile");
    }

    let frontImageId = "";
    getFrontpageImages(1, 0).then((imageList) => {
      if (imageList === undefined) return;
      for (const item of imageList.listOfContent) {
        if (item.contentTypeGuid === "17c15981-758d-4d09-a7ee-b2d47d2af6f0") {
          const meta = contentMeta(item);
          frontImageId = meta.imageContentId;
          getImageByContentId(frontImageId, (img) => {
            const viewMode = isMobile() ? "_mobile" : "";
            const elmDialog = document.querySelector(".chatbot-search--container");
            const maskImage = window.serverdata.configMeta.aim?.frontImageMask ? `url(${window.serverdata.configMeta.aim?.frontImageMask}), ` : "";
            const maskPosition = window.serverdata.configMeta.aim?.frontImageMask
              ? `calc(var(--dialog__cb__image_horizontal-position${viewMode}, center) - 1px) var(--dialog__cb__image_vertical-position${viewMode}, center), `
              : "";

            if (!isMobile()) {
              let url = img.url || window.serverdata.configMeta.aim.frontImage;
              if (url.includes("preview.sdl.no")) {
                url = url.replace("https://preview.sdl.no", `${window.apiUrl.replace("/api", "")}/proxy/ntbpreview`);
              }

              const bgImage = `https://res.cloudinary.com/ssp/image/fetch/g_auto,c_fill,f_auto/${url}`;
              elmDialog.dataset.background = bgImage;
              elmDialog.style.backgroundImage = `${maskImage}url('${bgImage}')`;

              //elmDialog.style.backgroundSize = `var(--dialog__cb__image_size${viewMode}, cover)`;
              elmDialog.style.backgroundPosition = `${maskPosition}var(--dialog__cb__image_horizontal-position${viewMode}, center) var(--dialog__cb__image_vertical-position${viewMode}, center)`;
              elmDialog.style.backgroundRepeat = "no-repeat";

              // add image to dialog__overlay__graph-right div
              const elmDialogImgDiv = document.querySelector(".dialog__overlay__graph-right");
              elmDialogImgDiv.style.backgroundImage = `${maskImage}url('${bgImage}')`;
              elmDialogImgDiv.querySelector("img").src = bgImage;
            }
          });
        }
      }
    });

    initBotInstance();
    hideChat(true);
  };

  KariStartTemplate();
  /* Events */
  dialogEvents();
}
